<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">{{ $t('intro.title') }}</h1>
        <p class="bannerSubtitle" v-html="$t('intro.text')"></p>
      </div>
    </section>

    <!--Dynablast-->
    <section id="dynablast" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="d-flex align-center justify-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('modelDynablast.title') }}</h2>
            <p class="mt-5" v-html="$t('modelDynablast.text')"></p>
            <ol class="olPad">
              <li v-html="$t('modelDynablast.ol1')"></li>
              <li v-html="$t('modelDynablast.ol2')"></li>
              <li v-html="$t('modelDynablast.ol3')"></li>
              <li v-html="$t('modelDynablast.ol4')"></li>
              <li v-html="$t('modelDynablast.ol5')"></li>
              <li v-html="$t('modelDynablast.ol6')"></li>
              <li v-html="$t('modelDynablast.ol7')"></li>
            </ol>
            <p class="f-secondary" v-html="$t('modelDynablast.subtxt')"></p>
            <ul class="olPad">
              <li v-html="$t('modelDynablast.ul1')"></li>
              <li v-html="$t('modelDynablast.ul2')"></li>
              <li v-html="$t('modelDynablast.ul3')"></li>
              <li v-html="$t('modelDynablast.ul4')"></li>
            </ul>
            <p class="f-secondary mt-5" v-html="$t('modelDynablast.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/Dynablast.jpg')">
            <div class="dynablastImg photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Kodiak 3250-->
    <section id="kodiak3250" class="v-tierce2 sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/KC3250.jpg')">
            <div class="kodiak3250Img photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="d-flex align-center justify-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('modelKodiak3250.title') }}</h2>
            <p class="mt-5" v-html="$t('modelKodiak3250.text')"></p>
            <ol class="olPad">
              <li v-html="$t('modelKodiak3250.ol1')"></li>
              <li v-html="$t('modelKodiak3250.ol2')"></li>
              <li v-html="$t('modelKodiak3250.ol3')"></li>
              <li v-html="$t('modelKodiak3250.ol4')"></li>
              <li v-html="$t('modelKodiak3250.ol5')"></li>
              <li v-html="$t('modelKodiak3250.ol6')"></li>
              <li v-html="$t('modelKodiak3250.ol7')"></li>
            </ol>
            <p class="f-secondary" v-html="$t('modelKodiak3250.subtxt')"></p>
            <ul class="olPad">
              <li v-html="$t('modelKodiak3250.ul1')"></li>
              <li v-html="$t('modelKodiak3250.ul2')"></li>
              <li v-html="$t('modelKodiak3250.ul3')"></li>
              <li v-html="$t('modelKodiak3250.ul4')"></li>
            </ul>
            <p class="f-secondary mt-5" v-html="$t('modelKodiak3250.bottomTxt')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Kodiak 2100-->
    <section id="kodiak2100" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="d-flex align-center justify-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle">{{ $t('modelKodiak2100.title') }}</h2>
            <p class="mt-5" v-html="$t('modelKodiak2100.text')"></p>
            <ol class="olPad">
              <li v-html="$t('modelKodiak2100.ol1')"></li>
              <li v-html="$t('modelKodiak2100.ol2')"></li>
              <li v-html="$t('modelKodiak2100.ol3')"></li>
              <li v-html="$t('modelKodiak2100.ol4')"></li>
              <li v-html="$t('modelKodiak2100.ol5')"></li>
              <li v-html="$t('modelKodiak2100.ol6')"></li>
              <li v-html="$t('modelKodiak2100.ol7')"></li>
            </ol>
            <p class="f-secondary" v-html="$t('modelKodiak2100.subtxt')"></p>
            <ul class="olPad">
              <li v-html="$t('modelKodiak2100.ul1')"></li>
              <li v-html="$t('modelKodiak2100.ul2')"></li>
              <li v-html="$t('modelKodiak2100.ul3')"></li>
              <li v-html="$t('modelKodiak2100.ul4')"></li>
            </ul>
            <p class="f-secondary mt-5" v-html="$t('modelKodiak2100.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/KC2100.jpg')">
            <div class="kodiak2100Img photoImg">
              <div class="photoHoverOverlay">
                <span class="zoomIcon" v-html="zoomSvg"></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Easy Clean-->
    <section id="easyClean" class="v-primary-light-1 sectionPad gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <div class="padPump">
            <h2 class="pumpSectionTitle txt-c">{{ $t('easyClean.title') }}</h2>
            <p class="mt-5" v-html="$t('easyClean.text')"></p>
            <ol class="olPad">
              <li v-html="$t('easyClean.ol1')"></li>
              <li v-html="$t('easyClean.ol2')"></li>
              <li v-html="$t('easyClean.ol3')"></li>
              <li v-html="$t('easyClean.ol4')"></li>
              <li v-html="$t('easyClean.ol5')"></li>
              <li v-html="$t('easyClean.ol6')"></li>
            </ol>
            <p class="f-secondary" v-html="$t('easyClean.subtxt')"></p>
            <ul class="olPad">
              <li v-html="$t('easyClean.ul1')"></li>
              <li v-html="$t('easyClean.ul2')"></li>
              <li v-html="$t('easyClean.ul3')"></li>
              <li v-html="$t('easyClean.ul4')"></li>
              <li v-html="$t('easyClean.ul5')"></li>
            </ul>
            <p class="f-secondary mt-5" v-html="$t('easyClean.bottomTxt')"></p>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10 d-flex justify-center">
        <v-col cols="12" class="d-flex justify-center flex-wrap">
          <div v-for="(item, i) in easyCleanPumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay">
              <span class="zoomIcon" v-html="zoomSvg"></span>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Accessoires-->
    <section class="sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-2">
          <h2 class="pumpSectionTitle">{{ $t('Accessoires.title') }}</h2>
        </v-col>
      </v-row>
      <accesories/>
    </section>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">
          <button class="lightboxClose" @click="closeLightbox">&times;</button>
          <img class="lightboxImg" :src="lightboxSrc" alt="Photo laveuse haute pression"/>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .gridpad { padding-bottom: 50px; }
  .sectionPad { padding: 50px 0px; }
  .padPump { text-align: justify; padding: 15px 50px; }
  .olPad { padding: 0px 40px; }
  ol li, ul li { padding: 8px 0px; font-size: 18px; color: rgba(var(--menuColor), 0.6); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../../public/Resources/images/Banner/bannerHighPressureWasher.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  .bannerSubtitle {
    color: rgba(255,255,255,0.85);
    font-size: 17px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  /*#endregion*/

  /*#region Photo Cards*/
  .photoCard {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.18);
    cursor: pointer;
    width: 100%;
    max-width: 520px;
    margin: 20px auto;
  }
  .photoImg {
    height: 420px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: rgba(var(--tierce2), 1);
    transition: transform 0.4s ease;
    position: relative;
  }
  .photoCard:hover .photoImg { transform: scale(1.03); }
  .photoHoverOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.30); }
  .zoomIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6));
  }
  .photoCard:hover .zoomIcon { opacity: 1; }
  .pumpThumbCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Image backgrounds*/
  .dynablastImg  { background-image: url("../../../public/Resources/images/Products/Dynablast.jpg"); }
  .kodiak3250Img { background-image: url("../../../public/Resources/images/Products/KC3250.jpg"); }
  .kodiak2100Img { background-image: url("../../../public/Resources/images/Products/KC2100.jpg"); }
  /*#endregion*/

  /*#region Thumbnails*/
  .pumpThumbCard {
    position: relative;
    display: inline-block;
    margin: 8px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
    border: 4px solid rgb(var(--secondary));
  }
  .pumpThumbImg { height: 220px; width: auto; object-fit: cover; display: block; }
  .pumpThumbOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .pumpThumbCard:hover .pumpThumbOverlay { background-color: rgba(0,0,0,0.35); }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightboxContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
  }
  .lightboxImg {
    max-width: 88vw;
    max-height: 88vh;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    object-fit: contain;
    display: block;
  }
  .lightboxClose {
    position: fixed;
    top: 20px;
    right: 28px;
    font-size: 44px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1;
    opacity: 0.85;
    transition: opacity 0.2s;
    z-index: 100001;
  }
  .lightboxClose:hover { opacity: 1; }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .padPump { padding: 15px; }
    .olPad { padding: 0px 15px; }
    .photoImg { height: 260px; }
    .pumpThumbImg { height: 160px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .sectionPad { padding: 30px 0px; }
    .padPump { padding: 15px 20px; }
    .photoImg { height: 300px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .padPump { padding: 15px 30px; }
  }
</style>

<script>
  import pageTranslations from '../../../public/Resources/i18N/highPressureWasher.json';
  import contactUs from '@/components/bannerContactUs.vue';
  import accesories from '@/components/accesories.vue';

  export default {
    name: 'highPressureWasher',
    data: () => ({
      parallaxOffset: 0,
      lightboxOpen: false,
      lightboxSrc: '',
      zoomSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="22" y2="22"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>',
      easyCleanPumps: [
        { img: '/Resources/images/Products/QuakerBlast.jpg' }
      ],
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox(src) {
        this.lightboxSrc = src;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      handleKeydown(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape') this.closeLightbox();
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    components: {
      contactUs,
      accesories,
    },
  }
</script>